import { userDataStore } from "./store";

const call = (axios) => {
  return new Promise((resolve, reject) => {
    axios
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
        // Only 401 means the session is gone. A 403 is an authorization failure — the
        // user is signed in but lacks the role — and must not drop the session, which
        // would bounce them through the identity provider instead of showing the error.
        if (error.response?.status === 401) {
          userDataStore.setAuthenticated(false);
        }
      });
  });
};

export default call;
